<template>
  <DatatableReport
    id="toDo_report"
    ref="toDos_datatable"
    no-download
    :source="source"
    :config="config"
    :map-records="applyFilter"
    :filters="filters"
  />
</template>

<script>
import { mapActions } from "vuex";
import { EventBus } from "@/lib/event_bus.js";

import DatatableCheckbox from "@/Reports/DatatableCheckbox.vue";
import DatatableReport from "@/Reports/DatatableReportV3.vue";
import ItemSummary from "./ItemSummary.vue";

export default {
  components: {
    DatatableReport
  },
  props: {
    source: {
      type: String,
      default: ""
    },
    filters: {
      type: Array,
      default: () => []
    },
    recordFilter: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      config: {
        order: [[4, "asc"]],
        columns: [
          {
            data: "created_at",
            title: "Date Created",
            className: "date-column"
          },
          { data: "assigned_to", title: "Assigned to" },
          { data: "created_by", title: "Created by" },
          {
            data: "summary",
            title: "To-Do",
            className: "todo-column",
            orderable: false
          },
          { data: "due_by", title: "Due by", className: "date-column" },
          {
            data: "completed",
            title: "Done",
            orderable: false,
            className: "text-center"
          }
        ],
        vueComponents: [
          {
            rootId: "datatable-checkbox-vue",
            component: DatatableCheckbox
          },
          {
            rootId: "item-summary-vue",
            component: ItemSummary
          }
        ]
      }
    };
  },
  mounted() {
    EventBus.$on("datatable-checkbox-change", this.handleCheck);
    EventBus.$on("refresh-todos-table", this.refreshData);
  },
  beforeUnmount() {
    EventBus.$off("datatable-checkbox-change", this.handleCheck);
    EventBus.$off("refresh-todos-table", this.refreshData);
  },
  methods: {
    ...mapActions(["setToDoCompleted", "fetchTodo", "fetchIncompleteTodos"]),
    handleCheck({ value }) {
      this.setToDoCompleted(value).then(() => this.refreshData());
    },
    refreshData() {
      EventBus.$emit("refresh-datatable");
    },
    applyFilter(record) {
      const adminId = window.currentTenant.user_id;
      if (this.recordFilter === "assigned_to") {
        return {
          ...record,
          owner_id: adminId
        };
      }
      if (this.recordFilter === "created_by") {
        return {
          ...record,
          author_id: adminId
        };
      }
      return record;
    }
  }
};
</script>

<style lang="scss"></style>
